import { lowerCase } from 'lodash'

export const ACCOUNT_DETAILS_FORM_NAME = 'accountDetails'
export const PERSONAL_DETAILS_FORM_NAME = 'personalDetails'
export const PROFESSIONAL_DETAILS_FORM_NAME = 'professionalDetails'
export const USER_BILLING_ADDRESS_FORM_NAME = 'userBillingAddress'
export const AVATAR_FORM_NAME = 'avatar'

export const analyticsFormName = (name) => `Update Profile - ${lowerCase(name)}`
